import __request__ from "routing/request";
export function cancelAsyncSearchJob(jobId, nodeId) {
  return __request__("DELETE", `/views/searchjobs/${nodeId}/${jobId}/cancel`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function asyncSearchJobStatus(jobId, nodeId, page = 0, per_page = 0) {
  return __request__("GET", `/views/searchjobs/${nodeId}/${jobId}/status`, null, { "page": page, "per_page": per_page }, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  });
}
